import React, {useEffect, useState} from 'react';
import {Controller, SubmitHandler, useForm} from 'react-hook-form';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Snackbar,
    Stack,
    Tooltip,
    Typography,
} from '@mui/material';
import {yupResolver} from '@hookform/resolvers/yup';
import {fnAlertPrep, useCreateVersOre2, useGetAppUserProgettiDTO, validationSchemaVersOre2} from './Services';
import {VersOre2} from './types';
import * as Yup from "yup";
import {FormField} from '../../common/FormField';
import {  useFieldsVersOre2_1,  useFieldsVersOre2_2,  useFieldsVersOre2_3,  useFieldsVersOre2_4,  useFieldsVersOre2_5} from './FormVersOre2';
import ReportProg from "../reports/ReportProg";
import SummarizeIcon from "@mui/icons-material/Summarize";
import {useGetDropProgettiByCodDip} from "../../common/Services";
import VersOreNoteAssist, {clampVersOreNote, loadVersOreCopilotConfig} from "../gestversore/VersOreNoteAssist";
import {fnCalcolaPM} from "../gestprev/Services";

interface AddVersOre2Props {
  open: boolean;
  onClose: () => void;
  defaultDate?: Date | null;

}

const AddVersOre2: React.FC<AddVersOre2Props> = ({ open, onClose   }) => {

      type VersOre2Form = Yup.InferType<typeof validationSchemaVersOre2>


  const { control, handleSubmit, reset,watch,setValue } = useForm<VersOre2Form>({
    resolver: yupResolver(validationSchemaVersOre2),
     defaultValues: {
            idprog: "",
            idnodo: "",
            idatt: "",
            datareg: new Date(),
            datains: new Date(),
            luogo: 'SEDE',
            orestraord: 0,
            minstraord: 0,
         // percomp:  0,
         // minpian: 0,
         // orepian: 0,
         // orainiz: 9,
         // mininiz: 0,
         // orafine: 18,
         // minfine: 0,
         // ref: '',
     },
  });

        const {data: DropProgettiApiResponse} = useGetDropProgettiByCodDip();


const [indclibloc, setIndclibloc] = useState<number>(0);

const [openAlert, setOpenAlert] = useState(false);

const [numAlertPrep, setNumAlertPrep] = useState<number>(0);



useEffect(() => {
  if (indclibloc === 2) {
    setOpenAlert(true);
  }
}, [indclibloc]);

const isBlocked = indclibloc === 2;

const [openReport, setOpenReport] = useState(false);

  const watchLuogo = watch('luogo');
  const watchOreStraord = watch('orestraord');
  const watchMinStraord = watch('minstraord');
  const watchIdProg = watch("idprog");

   const keycoddip = localStorage.getItem("keycoddip") || "";

   const { data: appUserProgDTO } = useGetAppUserProgettiDTO(
      watchIdProg,
      keycoddip
    );

  const molt =  parseFloat(String(appUserProgDTO?.results?.[0]?.molt).replace(",", ".")) || 1;

useEffect(() => {
  if (!watchIdProg) return;
  fnAlertPrep(watchIdProg)
    .then(res => {
        const num = Number(res?.numalertprep) || 0;
      setNumAlertPrep(num);
     })
    .catch(console.error);
}, [watchIdProg]);


  useEffect(() => {
  const ore = Number(watchOreStraord) || 0;
  const minuti = Number(watchMinStraord) || 0;
  const moltiplicatore = molt || 1;

  // 1️⃣ Converto tutto in minuti
  const minutiTotali = (ore * 60 + minuti) * moltiplicatore;

  // 2️⃣ Converto in ore arrotondate per eccesso
  let oreCalcolate = Math.ceil(minutiTotali / 60);

  // 3️⃣ Regola TRASFERTA applicata DOPO il calcolo
  if (watchLuogo === 'TRASFERTA') {
    oreCalcolate = oreCalcolate <= 4 ? 4 : 8;
  }
  setValue("oreord", oreCalcolate);

}, [watchOreStraord, watchMinStraord, watchLuogo, molt,setValue]);




  const editOpzione = false;

  const f1 = useFieldsVersOre2_1(editOpzione,isBlocked);
  const f2 = useFieldsVersOre2_2(watchIdProg,setValue, setIndclibloc,isBlocked);
  const f3 = useFieldsVersOre2_3(isBlocked);
  const f4 = useFieldsVersOre2_4(isBlocked);
  const f5 = useFieldsVersOre2_5(isBlocked);


  const { mutateAsync, isPending } = useCreateVersOre2();

  const onSubmit: SubmitHandler<VersOre2Form> = async data => {
    // console.log("FINAL FORM DATA:", data);
    const copilotConfig = await loadVersOreCopilotConfig();

    const codprog = data.idprog?.split("-")[1] ?? "";
    const codnodo = data.idnodo?.split("-")[2] ?? "";
    const codatt  = data.idatt?.split("-")[2] ?? "";
    const ditta = Number(data.idprog?.split("-")[0]) || 0;
    const coddip = localStorage.getItem('keycoddip') || '';

    const payload = {
                  ...data,
                  indlavoraz: 0,
                  indora: 0,
                  indtipovers: 2,
                  valutadqr: "EURO",
                  umtempodqr: 2,
                  indtipocosdqr: 0,
                  costodqr: 30,
                  impdqr: 90,
                  protocollo: 1037,
                  // coddip: localStorage.getItem("coddip") || "",
                  minord: 0,
                  ditta,
                  codprog,
                  codnodo,
                  codatt,
                  coddip,
                  note: clampVersOreNote(data.note || '', copilotConfig.noteMaxLength).value,
                };

    await mutateAsync(payload as VersOre2);
    onClose();
  };





  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6">Nuovo Time report</Typography>
         {watchIdProg && (
                              <Tooltip title="Report Nodi Progetto" arrow>
                                  <IconButton
                                    size="large"
                                    color="primary"
                                    onClick={() => setOpenReport(true)}
                                  >
                                    <SummarizeIcon sx={{ fontSize: 30 }} />
                                  </IconButton>
                              </Tooltip>
                                )}
      </DialogTitle>

      <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)}>
                  <Stack spacing={1}>
                      <Stack direction="row" spacing={1}>{f1.map(f => <FormField key={String(f.name)} control={control}
                                                                                 field={f}/>)}</Stack>
                      <Stack direction="column" spacing={1}>{f2.map(f => <FormField key={String(f.name)}
                                                                                    control={control}
                                                                                    field={f}/>)}</Stack>
                      <Stack direction="row" spacing={1}>{f3.map(f => <FormField key={String(f.name)} control={control}
                                                                                 field={f}/>)}</Stack>
                      <Stack direction="row" spacing={1}>{f4.filter(f => f.name !== "note").map(f => <FormField key={String(f.name)} control={control}
                                                                                 field={f}/>)}</Stack>
                      <Controller
                          name="note"
                          control={control}
                          render={({ field, fieldState }) => (
                              <VersOreNoteAssist
                                  textFieldId="versore2-add-note"
                                  value={String(field.value || '')}
                                  onChange={field.onChange}
                                  error={!!fieldState.error}
                                  helperText={fieldState.error?.message}
                                  disabled={isBlocked}
                              />
                          )}
                      />
                      <Stack direction="row" spacing={1}>{f5.map(f => <FormField key={String(f.name)} control={control}
                                                                                 field={f}/>)}</Stack>
                      <Stack direction="row" justifyContent="flex-end" spacing={2}>
                          <Button onClick={onClose} color="error">Annulla</Button>
                          <Button type="submit" variant="contained" disabled={isPending || isBlocked}>
                              {isPending ? 'Salvando…' : 'Salva'}
                          </Button>
                      </Stack>
                  </Stack>
          </form>
      </DialogContent>
    </Dialog>

    <Dialog
      open={openReport}
      onClose={() => setOpenReport(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Report Nodi Progetto</DialogTitle>

      <DialogContent>
       <ReportProg key={watchIdProg} idprogprop={watchIdProg} />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenReport(false)}>Chiudi</Button>
      </DialogActions>
    </Dialog>


 <Snackbar
  open={openAlert}
  autoHideDuration={3000}
  onClose={() => setOpenAlert(false)}
   anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert severity="error" variant="filled">
    Cliente sospeso: inserimento non consentito
  </Alert>
</Snackbar>


 <Snackbar
   open={numAlertPrep < 0}
   autoHideDuration={3000}
   anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
 >
   <Alert severity="error" variant="filled">
     Alert ORE PREP verificare monitor progetti e avvertire commerciale
   </Alert>
 </Snackbar>

  </>

  );
};

export default AddVersOre2;
